import { TableauReport } from "../types/TableauReport";

export function normalizeTableauConfig(tableau: any): TableauReport[] {
  if (!tableau) return [];


  if (Array.isArray(tableau)) return tableau;

  // object-map → array
  if (typeof tableau === "object") {
    return Object.entries(tableau).map(([path, value]: any) => ({
      path,
      label: value?.label,
      src: value?.src,
      roles: value?.roles || [],
    }));
  }

  return [];
}

export function filterReportsByRoles(
  reports: TableauReport[],
  rolesSet: Set<string>
): TableauReport[] {
  return reports.filter((r) => {
    if (!r.roles || r.roles.length === 0) return false;
    return r.roles.some((role) => rolesSet.has(role));
  });
}

export function getAllowedTableauReports(
  parsedTenantAttribute: any,
  rolesSet: Set<string>
): TableauReport[] {
  const reports = normalizeTableauConfig(parsedTenantAttribute?.tableau);
  return filterReportsByRoles(reports, rolesSet);
}
